import { DoubleCheckCircle } from '../components/svg-icons/DoubleCheckCircle';

import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';

export type ColorKey =
  | 'related'
  | 'relevant'
  | 'perfectlyRelevant'
  | 'notRelevant';

export type TextDecoration =
  | 'overline'
  | 'line-through'
  | 'underline'
  | 'underline overline'
  | 'none';

export interface RelevanceJudgementItem {
  relevance: number;
  description: string;
  colorKey: ColorKey;
  textDecoration: TextDecoration;
  IconComponent: React.ElementType;
}

export const relevanceJudgementsMapping: Array<RelevanceJudgementItem> = [
  {
    relevance: 0,
    description: 'Not Relevant',
    colorKey: 'notRelevant',
    textDecoration: 'line-through',
    IconComponent: CheckIcon,
  },
  {
    relevance: 1,
    description: 'Somewhat Relevant',
    colorKey: 'related',
    textDecoration: 'none',
    IconComponent: CheckIcon,
  },
  {
    relevance: 2,
    description: 'Relevant',
    colorKey: 'relevant',
    textDecoration: 'none',
    IconComponent: DoneAllIcon,
  },
  {
    relevance: 3,
    description: 'Perfectly Relevant',
    colorKey: 'perfectlyRelevant',
    textDecoration: 'none',
    IconComponent: DoubleCheckCircle,
  },
];
